import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PageNotFound.module.scss';
import SiteHeader from '../../components/organism/site-header/SiteHeader';
import Text from '../../components/atoms/text/Text';

const pageNotFoundSvg = '/assets/svg/errors/page-not-found.svg';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <SiteHeader isNormal={true} />
      <div className={styles['page-container']}>
        <img src={pageNotFoundSvg} alt="Page not found illustration" />
        <div className={styles['text-container']}>
          <Text
            title="pageNotFound.title"
            variant="text-regular-24"
            className={styles.title}
          />
          <Text
            title="pageNotFound.description"
            variant="text-regular-16"
            className={styles.desc}
          />
        </div>

        <button className={styles.button} onClick={() => navigate('/')}>
          <Text
            title="pageNotFound.backHome"
            variant="text-regular-16"
            className={styles.buttonText}
          />
        </button>
      </div>
    </>
  );
};

export default PageNotFound;
